import React from "react";
import { useParams, Navigate } from "react-router-dom";
import { blogPosts } from "./Blog";
import BlogArticleView from "./common/BlogArticleView";

const BlogPost = () => {
  const { postId } = useParams<{ postId: string }>();
  const post = blogPosts.find((p) => p.id === postId);
  if (!post) return <Navigate to="/blog" replace />;
  // 店舗固有記事の正規URLは /:region/blog/:postId のみ。
  // 同一記事が複数URLでインデックスされるのを避けるため、そちらへ誘導する。
  if (post.storeId && post.storeId !== "shared") {
    return <Navigate to={`/${post.storeId}/blog/${post.id}`} replace />;
  }

  const canonical = `https://tht-group.co.jp/blog/${post.id}`;
  const breadcrumbs = [
    { name: "TOP", item: "https://tht-group.co.jp/" },
    { name: "ブログ", item: "https://tht-group.co.jp/blog" },
    { name: post.title, item: canonical },
  ];

  return (
    <BlogArticleView
      post={post}
      canonical={canonical}
      ogType="article"
      breadcrumbs={breadcrumbs}
      backHref="/blog"
      backLabel="ブログ一覧へ戻る"
    />
  );
};

export default BlogPost;
